<template>
  <v-tooltip top content-class="restricted-tooltip-content">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="{ ...$attrs, ...attrs }"
        v-on="{ ...$listeners, ...on }"
        class="restricted-button"
      >
        <slot></slot>
      </v-btn>
    </template>
    <span>{{ tooltip_text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'RestrictedButton',
  inheritAttrs: false,
  props: {
    tooltip_text: {
      type: String,
      default: 'Staff Only'
    }
  }
}
</script>

<style lang="scss" scoped>
.restricted-button {
  border-left: 3px solid #e53935 !important;
  font-weight: 500;
}

::v-deep .restricted-tooltip-content {
  background-color: #e53935 !important;
  color: white !important;
}
</style>
